/* include the google places script in your layout component to use this function */

export const geocodeByAddress = (
  address: string,
  options?: {
    preservePoBox?: boolean;
    components?: google.maps.GeocoderComponentRestrictions;
  },
): Promise<google.maps.GeocoderResult[]> => {
  const geocoder = new window.google.maps.Geocoder();
  const { OK } = window.google.maps.GeocoderStatus;

  const poBoxPattern = /\b[P|p]\.?\s*[O|o]\.?\s*[B|b][Oo][Xx]\.?\s+\d+\b/;
  const hasPoBox = poBoxPattern.test(address);

  return new Promise((resolve, reject) => {
    const request: google.maps.GeocoderRequest = { address };

    if (options?.components) {
      request.componentRestrictions = options.components;
    }

    geocoder.geocode(
      request,
      (
        results: google.maps.GeocoderResult[] | null,
        status: google.maps.GeocoderStatus,
      ) => {
        if (status !== OK) {
          if (hasPoBox && options?.preservePoBox) {
            const poBoxResult: Partial<google.maps.GeocoderResult> = {
              formatted_address: address,
              address_components: [],
            };
            return resolve([poBoxResult as google.maps.GeocoderResult]);
          }
          return reject(status);
        }

        return resolve(results || []);
      },
    );
  });
};
